import React, { useContext } from "react";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { EnumsContext } from "../../context/EnumsContext";

// Nav eventKeys must be strings, so "no entity type filter" gets its own key.
const ALL_TAB_KEY = "all";

interface Props {
  value: string | null;
  onChange: (entityType: string | null) => void;
}

const EntityTypeTabs = ({ value, onChange }: Props) => {
  const { t } = useTranslation();
  const enumsContext = useContext(EnumsContext);
  const entityTypes: string[] = enumsContext?.enums?.auditEntityType ?? [];

  return (
    <Nav
      variant="tabs"
      activeKey={value ?? ALL_TAB_KEY}
      onSelect={(key) => onChange(!key || key === ALL_TAB_KEY ? null : key)}
      className="mb-3"
    >
      <Nav.Item>
        <Nav.Link eventKey={ALL_TAB_KEY}>{t("auditLog.allEntityTypes")}</Nav.Link>
      </Nav.Item>
      {entityTypes.map((entityType) => (
        <Nav.Item key={entityType}>
          <Nav.Link eventKey={entityType}>{t(`enums.auditEntityType.${entityType}`, entityType)}</Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default EntityTypeTabs;
